import { PDF_CONTENT_REF, PDF_FOOTER_REF, PDF_HEADER_REF } from 'common/constants/domRefs';

export const getPdfDom = (doc: Document) => ({
  header: doc.querySelector(`[data-ref="${PDF_HEADER_REF}"]`),
  content: doc.querySelector(`[data-ref="${PDF_CONTENT_REF}"]`),
  footer: doc.querySelector(`[data-ref="${PDF_FOOTER_REF}"]`),
});


